import { RelatedContract } from "./contract";

export interface InsuredGood extends Omit<MyBrokerApi.InsuredGoods, "relatedContracts"> {
    relatedContracts?: RelatedContract[];
    categoryOrder?: string;
}

export type InsuredGoodSortProperty = Paths.ApiInsuredGood.Get.Parameters.SortProperty;

export type InsuredGoodCategory = MyBrokerApi.CategoryCounters;

export interface InsuredGoodDetails extends MyBrokerApi.InsuredGood {}

export enum InsuredGoodCategoryType {
    ALL = "0",
}

export interface InsuredGoodPagination extends Omit<MyBrokerApi.InsuredGoodsPayload, "result"> {
    result: InsuredGood[];
}

export const defaultInsuredGoodPagination = { result: [] as InsuredGood[], total: 0 };

export const STAKEHOLDER_TYPE_ID_DRIVER = "02";
export const STAKEHOLDER_TYPE_ID_LEASING_COMPANY = "05";
